<script setup lang="ts">
import { useForm } from 'vee-validate'

const { fields, initialValues } = defineProps<{
  fields?: FieldContent[]
  initialValues?: any
  submit?: (values: Record<string, any>) => Promise<boolean | void>
}>()

const emit = defineEmits(['submit'])
const defaultValues = fields?.reduce((res, field) => {
  res[field.name] = field.initialValue
  return res
}, {})

const { handleSubmit, values, resetForm, setFieldError, setFieldValue, setValues, validate } = useForm({ initialValues: defaultValues })
onMounted(() => {
  setValues({ ...values, ...initialValues }, false)
})
const onSubmit = handleSubmit.withControlled(values => emit('submit', values), () => {
  document.getElementsByClassName('scroll-error-class')?.[0].scrollIntoView({ block: 'center', behavior: 'smooth' })
})
defineExpose({ values, setFieldError, setFieldValue, setValues, validate, defaultValues, submit: onSubmit })

provide('form-fields', fields)
</script>

<template>
  <form v-bind="$attrs" @submit="onSubmit">
    <slot :values="values" :reset-form="resetForm" />
  </form>
</template>
